import React, { useState } from 'react';
import '../../css/FAQs.css';

const FAQNNAT = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is the Naglieri Nonverbal Ability Test (NNAT)?",
      answer: "The Naglieri Nonverbal Ability Test (NNAT) is a standardized assessment designed to measure a student's nonverbal reasoning and problem-solving abilities. Unlike traditional tests, NNAT focuses on pattern recognition, spatial reasoning, and logical thinking without relying on language or mathematical skills, making it ideal for assessing students from diverse backgrounds and those with language barriers."
    },
    {
      question: "Why is the NNAT test important for elementary school students?",
      answer: "The NNAT test is important because it helps identify students who may benefit from gifted and talented programs. Since it doesn't rely on language or math skills, it provides a fair assessment of cognitive abilities for students from diverse backgrounds, English language learners, and students with different learning styles. Many school districts use NNAT scores for gifted program identification and academic placement."
    },
    {
      question: "How can my child prepare for the NNAT test?",
      answer: "The best way to prepare for NNAT is through regular practice with sample questions from all four key areas (Pattern Completion, Reasoning by Analogy, Serial Reasoning, and Spatial Visualization). Familiarize your child with pattern recognition, spatial reasoning exercises, and visual problem-solving. Our free practice platform offers thousands of NNAT sample questions with detailed explanations to help students build confidence and improve their performance."
    },
    {
      question: "What grade levels take the NNAT test?",
      answer: "The NNAT test is typically administered to students in grades K-12, with age-appropriate question sets for each grade level. Many school districts administer it at specific grade levels (often grades 2, 4, or 6) for gifted program identification. The test format and difficulty are adjusted based on the student's grade level, ensuring age-appropriate assessment."
    },
    {
      question: "What types of questions are on the NNAT test?",
      answer: "The NNAT test includes multiple-choice questions across four key areas: Pattern Completion (identifying missing portions of visual patterns), Reasoning by Analogy (recognizing relationships between shapes), Serial Reasoning (identifying patterns in sequences), and Spatial Visualization (mentally manipulating shapes). All questions are visual-based and designed to assess nonverbal reasoning abilities."
    },
    {
      question: "How long does the NNAT test take?",
      answer: "The NNAT test typically takes 30-45 minutes to complete, though it may vary slightly by grade level and school district. The test is usually administered in a single session, making it less time-consuming than many other standardized assessments. The exact timing can vary based on the specific version of the test and the student's grade level."
    },
    {
      question: "How is the NNAT test scored?",
      answer: "NNAT scores are reported using several metrics including raw scores, standard age scores (SAS), percentile ranks, and stanines. Scores are compared to national norms for the student's age group. Higher scores indicate stronger nonverbal reasoning abilities. Many gifted programs look for students scoring in the 90th percentile or higher. The nonverbal nature of the test makes it particularly useful for identifying gifted students who may not excel in traditional language-based assessments."
    },
    {
      question: "Can students practice for the NNAT test online?",
      answer: "Yes! Students can practice for the NNAT test using online practice platforms like SmartKids Prep, which offers free access to thousands of NNAT sample questions. Online practice helps students become familiar with the question formats, timing, and types of visual reasoning required. Practice tests are available for all four key areas with detailed explanations for each answer, helping students understand the reasoning behind correct solutions."
    }
  ];

  return (
    <section className="nnat-faq-section" aria-label="NNAT Frequently Asked Questions">
      <div className="nnat-faq-wrapper">
        <h2 className="nnat-faq-title">
          Frequently Asked Questions About NNAT
        </h2>
        <p className="nnat-faq-intro">
          Find answers to common questions about the Naglieri Nonverbal Ability Test (NNAT), test preparation, scoring, and more.
        </p>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleQuestion(index)}
                style={{ cursor: 'pointer' }}
              >
                {faq.question}
                <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                  {openIndex === index ? '-' : '+'}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQNNAT;
